<portal-layout [config]="layoutConfig">
  <div class="portal-section text-center">
    <div class="portal-heading text-primary">We’re Sorry!</div>

    <router-outlet></router-outlet>

    <p>
      For any enquiries, please contact
      <a
        [href]="contactUsPage"
        class="text-primary underline"
        target="_blank"
        >CIMB service centre</a
      >
    </p>

    <a
      [href]="homePage"
      class="portal-button-primary"
    >
      Back to Home Page
    </a>
  </div>
</portal-layout>
